var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRelaxation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 145,
    viewBox: "0 0 122 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.4828 70.3779L60.9916 70.052L70.9942 0.0993652L74.7499 0.503436L64.4828 70.3779Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9793 10.3198L61.9482 69.9675L63.4873 70.2005L72.5184 10.5529L70.9793 10.3198Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3816 10.6723L72.6887 1.40097",
    stroke: "#263238",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.961 30.1756C64.7901 -16.8884 17.6163 18.722 17.6163 18.722L119.961 30.1756Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.675 28.8573C65.3059 -14.9332 21.3534 18.2434 21.3534 18.2434L116.675 28.8573Z",
    fill: "#02BEB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.54333 57.0286L6.35868 65.6128L9.30808 74.6066L12.1234 83.1908L15.0728 92.1846L17.8882 100.769L20.8394 109.763L23.6548 118.347L26.6042 127.341L29.4195 135.925L32.1008 144.101L79.9784 128.396L77.2971 120.22L74.4818 111.636L71.5323 102.642L68.717 94.0579L65.7657 85.064L62.9504 76.4799L60.001 67.4879L57.1856 58.9019L54.2362 49.9099L51.4209 41.3257L3.54333 57.0286Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9991 42.826L5.15955 57.8625L32.7688 142.038L78.6084 127.002L50.9991 42.826Z",
    fill: "#02BEB2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M50.9987 42.8273L5.15918 57.8638L7.88094 66.1619L53.7205 51.1255L50.9987 42.8273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M56.5721 59.8199L10.7325 74.8564L13.4543 83.1545L59.2939 68.118L56.5721 59.8199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M62.1449 76.8119L16.3053 91.8484L19.0271 100.147L64.8666 85.1101L62.1449 76.8119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M67.7183 93.8045L21.8788 108.841L24.6005 117.139L70.4401 102.103L67.7183 93.8045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M73.2916 110.797L27.452 125.834L30.1738 134.132L76.0133 119.095L73.2916 110.797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4201 79.003C41.4201 79.003 50.4545 67.2719 43.6954 64.0114C36.9364 60.7509 29.8925 62.6298 29.8925 62.6298L30.6056 64.8028C30.6056 64.8028 47.8254 66.596 36.9941 76.2751L41.4201 79.003Z",
    fill: "#FFE0D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1405 83.6862C27.1405 83.6862 12.9111 79.5896 16.4285 72.955C19.9458 66.3204 26.7402 63.667 26.7402 63.667L27.4533 65.84C27.4533 65.84 14.6409 77.4836 29.1012 78.8746L27.1405 83.6862Z",
    fill: "#FFE0D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.0224 72.7614C19.9234 67.2962 25.0457 64.5291 26.7513 63.7265L26.7327 63.667C26.7327 63.667 19.9476 66.3297 16.4303 72.955C12.913 79.5803 27.1424 83.6862 27.1424 83.6862L27.2783 83.351C24.8782 82.5764 13.8924 78.6716 17.0224 72.7614Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M43.1033 64.2069C37.5285 61.5218 31.7619 62.3262 29.9129 62.6894L29.8943 62.6298C29.8943 62.6298 36.9401 60.7565 43.6973 64.0114C50.4545 67.2663 41.4219 79.003 41.4219 79.003L41.1128 78.8168C42.5913 76.7555 49.1325 67.1099 43.1033 64.2069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.979 77.3745C38.8721 75.4414 42.0824 69.0969 40.1494 63.2036C38.2164 57.3102 31.8722 54.0998 25.9791 56.0329C20.086 57.966 16.8757 64.3105 18.8087 70.2038C20.7417 76.0972 27.086 79.3076 32.979 77.3745Z",
    fill: "#FF7185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1727 99.309C36.1508 100.627 33.071 102.368 31.7676 98.3556L27.485 85.321C26.8552 83.3821 27.0183 81.2726 27.9386 79.4535C28.859 77.6343 30.4618 76.2533 32.397 75.6121C34.3359 74.9823 36.4452 75.1454 38.2643 76.0658C40.0834 76.9861 41.4643 78.589 42.1054 80.5243L46.388 93.5589C47.7007 97.5717 44.1927 97.9832 40.1727 99.309Z",
    fill: "#FF8976"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40.7648 99.1135L40.4688 99.2122C41.4612 98.8957 42.4145 98.6257 43.2617 98.337C42.4834 98.5847 41.6362 98.8286 40.7648 99.1135Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.3522 98.1526L28.0696 85.1181C27.4555 83.2284 27.594 81.1745 28.4563 79.3844C29.3185 77.5942 30.8381 76.2056 32.6986 75.5079C32.598 75.5359 32.4993 75.5657 32.3988 75.5973C30.4633 76.2381 28.86 77.6189 27.9393 79.4381C27.0186 81.2573 26.8552 83.3669 27.485 85.3062L31.7676 98.3407C32.801 101.489 34.9088 101.104 37.7073 100.156C35.1974 100.963 33.3112 101.076 32.3522 98.1526Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.7381 94.6314C46.7381 94.6314 55.9959 102.623 56.0481 109.547C56.0461 110.679 56.1189 111.811 56.2659 112.934L57.2807 122.803L53.067 123.967L51.4303 111.599C51.3384 110.906 51.0739 110.248 50.6613 109.684L47.0732 104.769C46.6873 104.24 46.1441 103.847 45.5212 103.647C44.8984 103.446 44.228 103.448 43.6062 103.651C43.1845 103.79 42.7974 104.017 42.4712 104.318C42.145 104.619 41.8873 104.987 41.7155 105.396C41.5437 105.805 41.4618 106.247 41.4755 106.69C41.4891 107.134 41.5979 107.57 41.7945 107.968L45.4216 115.312L48.7732 130.847L44.6154 132.21C44.6154 132.21 41.1223 120.224 38.1896 114.621C35.257 109.018 32.2145 99.4002 32.2145 99.4002L46.7381 94.6314Z",
    fill: "#5CAADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5896 72.5771L31.2588 72.6856C30.4771 72.942 30.0512 73.7836 30.3076 74.5654L31.3232 77.6617C31.5796 78.4434 32.4212 78.8693 33.2029 78.6129L33.5337 78.5043C34.3154 78.2479 34.7413 77.4063 34.4849 76.6246L33.4693 73.5283C33.2129 72.7465 32.3713 72.3207 31.5896 72.5771Z",
    fill: "#FFE0D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30.2389 74.3627C30.2389 74.3627 31.8756 74.9697 33.3596 73.3497L30.2389 74.3627Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8769 74.0145C35.9144 72.6901 38.1139 68.3433 36.7895 64.3056C35.4652 60.268 31.1186 58.0684 27.0811 59.3928C23.0435 60.7172 20.8441 65.064 22.1684 69.1017C23.4928 73.1394 27.8394 75.3389 31.8769 74.0145Z",
    fill: "#FFE0D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2714 61.4101C22.2714 61.4101 22.9659 67.5289 35.9515 61.0806L31.1699 57.1702L26.4981 57.6078L22.2714 61.4101Z",
    fill: "#FF7185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8196 69.5493C32.963 69.985 32.1698 70.8527 30.9706 71.2493C29.7715 71.646 28.6171 71.4114 28.4737 70.9738C28.3303 70.5362 29.252 70.0613 30.453 69.6703C31.654 69.2793 32.6762 69.121 32.8196 69.5493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.4156 67.4911L29.1895 67.8933C29.0918 67.9253 29.0386 68.0305 29.0706 68.1282L29.084 68.1689C29.116 68.2666 29.2212 68.3199 29.3189 68.2878L30.545 67.8856C30.6427 67.8536 30.6959 67.7484 30.6639 67.6507L30.6505 67.61C30.6185 67.5123 30.5133 67.459 30.4156 67.4911Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6009 66.2233C25.8188 66.1519 25.9375 65.9173 25.866 65.6994C25.7945 65.4815 25.56 65.3628 25.3421 65.4342C25.1242 65.5057 25.0054 65.7403 25.0769 65.9582C25.1484 66.1761 25.383 66.2948 25.6009 66.2233Z",
    fill: "#383F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3201 64.0194C32.538 63.9479 32.6567 63.7133 32.5852 63.4954C32.5138 63.2775 32.2792 63.1588 32.0613 63.2303C31.8434 63.3017 31.7247 63.5363 31.7962 63.7542C31.8676 63.9721 32.1022 64.0909 32.3201 64.0194Z",
    fill: "#383F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0161 65.6705L23.5877 67.4153C23.6492 67.6011 23.7813 67.7553 23.9555 67.8446C24.1297 67.9338 24.3321 67.9508 24.5187 67.892L27.4495 66.9311C27.6354 66.8697 27.7896 66.7376 27.8788 66.5634C27.968 66.3892 27.985 66.1868 27.9262 66.0001L27.3546 64.2553C27.2932 64.0695 27.1611 63.9153 26.9868 63.8261C26.8126 63.7369 26.6103 63.7198 26.4236 63.7787L23.4928 64.7395C23.3069 64.8009 23.1527 64.933 23.0635 65.1073C22.9743 65.2815 22.9573 65.4838 23.0161 65.6705ZM26.971 66.7729L24.8297 67.4749C24.643 67.5337 24.4407 67.5167 24.2665 67.4274C24.0922 67.3382 23.9601 67.184 23.8987 66.9982L23.5151 65.8269C23.4563 65.6402 23.4733 65.4379 23.5625 65.2637C23.6518 65.0894 23.806 64.9573 23.9918 64.8959L26.1331 64.1939C26.3198 64.1351 26.5221 64.1521 26.6964 64.2413C26.8706 64.3305 27.0027 64.4847 27.0641 64.6706L27.4477 65.8418C27.5063 66.029 27.4888 66.2318 27.3988 66.4061C27.3089 66.5804 27.1538 66.7122 26.9673 66.7729H26.971Z",
    fill: "#E75F7E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.1623 64.0697L23.8729 64.8206C23.5231 64.9354 23.3325 65.312 23.4473 65.6618L23.9388 67.1604C24.0535 67.5103 24.4301 67.7009 24.78 67.5861L27.0694 66.8351C27.4192 66.7204 27.6097 66.3438 27.495 65.9939L27.0035 64.4953C26.8887 64.1455 26.5121 63.9549 26.1623 64.0697Z",
    fill: "#E75F7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.537 65.2367L27.3508 65.1287C27.362 65.112 28.6114 63.3523 30.2537 64.1828L30.1606 64.369C28.6952 63.6242 27.5761 65.1734 27.537 65.2367Z",
    fill: "#E75F7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.916 65.7545C37.2592 65.7247 37.4809 65.051 37.4113 64.2498C37.3416 63.4486 37.0069 62.8233 36.6637 62.8532C36.3205 62.883 36.0987 63.5567 36.1684 64.3579C36.2381 65.1591 36.5728 65.7843 36.916 65.7545Z",
    fill: "#FFE0D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9251 70.345C23.2193 70.1657 23.1187 69.4637 22.7003 68.7769C22.2819 68.0901 21.7042 67.6786 21.41 67.8578C21.1158 68.0371 21.2165 68.7391 21.6349 69.4259C22.0533 70.1127 22.6309 70.5242 22.9251 70.345Z",
    fill: "#FFE0D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.5879 61.1252L22.2714 61.4101C22.2714 61.4101 22.9659 67.5289 35.9515 61.0805L35.4729 60.6895C25.271 65.57 23.0515 62.3747 22.5879 61.1252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7306 63.4677L30.3022 65.2125C30.3636 65.3983 30.4957 65.5525 30.67 65.6417C30.8442 65.7309 31.0465 65.748 31.2332 65.6892L34.164 64.7283C34.3498 64.6669 34.504 64.5348 34.5932 64.3605C34.6824 64.1863 34.6995 63.984 34.6407 63.7973L34.0765 62.0451C34.0151 61.8592 33.883 61.705 33.7087 61.6158C33.5345 61.5266 33.3322 61.5095 33.1455 61.5684L30.2147 62.5292C30.1212 62.5588 30.0344 62.6066 29.9594 62.6699C29.8843 62.7331 29.8226 62.8106 29.7776 62.8978C29.7326 62.985 29.7053 63.0803 29.6972 63.1781C29.6892 63.2759 29.7005 63.3743 29.7306 63.4677ZM33.6855 64.57L31.5442 65.272C31.3575 65.3309 31.1551 65.3138 30.9809 65.2246C30.8067 65.1354 30.6746 64.9812 30.6132 64.7953L30.2296 63.6241C30.1708 63.4374 30.1878 63.2351 30.277 63.0608C30.3662 62.8866 30.5204 62.7545 30.7063 62.6931L32.8476 61.9911C33.0342 61.9322 33.2366 61.9493 33.4108 62.0385C33.585 62.1277 33.7171 62.2819 33.7786 62.4677L34.1621 63.639C34.2209 63.8259 34.2036 64.0285 34.114 64.2028C34.0244 64.377 33.8698 64.509 33.6836 64.57H33.6855Z",
    fill: "#E75F7E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.8815 61.8657L30.5921 62.6167C30.2423 62.7314 30.0518 63.1081 30.1665 63.4579L30.658 64.9565C30.7728 65.3063 31.1494 65.4969 31.4992 65.3821L33.7886 64.6312C34.1384 64.5164 34.329 64.1398 34.2142 63.79L33.7227 62.2914C33.608 61.9415 33.2314 61.751 32.8815 61.8657Z",
    fill: "#E75F7E"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M38.9828 114.369C36.0501 108.766 33.0076 99.1489 33.0076 99.1489L32.2181 99.4077C32.2181 99.4077 35.2606 109.023 38.1933 114.628C41.1259 120.233 44.6153 132.21 44.6153 132.21L45.4048 131.951C45.4048 131.951 41.9136 119.965 38.9828 114.369Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.6154 132.21L45.9188 136.156L52.1024 135.659C52.1024 135.659 52.9645 134.282 51.4545 133.683C49.9444 133.083 48.7713 130.841 48.7713 130.841L44.6154 132.21Z",
    fill: "#FFFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9478 122.913L52.5511 126.561L58.4109 128.598C58.4109 128.598 59.7534 127.685 58.6138 126.529C57.4743 125.372 57.3104 122.848 57.3104 122.848L52.9478 122.913Z",
    fill: "#FFFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M45.0119 132.081L44.6172 132.212L45.9187 136.156L52.1024 135.659C52.1024 135.659 52.1266 135.621 52.1583 135.556L46.3135 136.025L45.0119 132.081Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M121.995 79.1613C122.499 69.6012 95.6006 60.4105 61.9154 58.6333C28.2302 56.8561 0.514102 63.1653 0.00975646 72.7253C-0.494589 82.2854 26.4038 91.4761 60.089 93.2533C93.7742 95.0305 121.49 88.7213 121.995 79.1613Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 81.3815,
    y1: 61.6194,
    x2: 53.7655,
    y2: 9.91512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 64146.1,
    y1: -23828.1,
    x2: 60513.2,
    y2: -30629.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 62329.2,
    y1: 69288.6,
    x2: 46565.3,
    y2: 21231.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 144,
    fill: "white",
    transform: "translate(0 0.0993652)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelaxation);
export default __webpack_public_path__ + "static/media/relaxation.83db9db9eaff4dcc35518746b0d8aa2a.svg";
export { ForwardRef as ReactComponent };